export default "__VITE_ASSET__d8016712__"